import * as React from 'react'
import { ShopConfig } from '../models/ShopConfig'

export const ShopConfigContext = React.createContext({
  shopConfig: null as ShopConfig | null,
})
